/* 曹操傳・第 12 章：定軍山與雞肋（建安二十四年，219）
 * 史實：《三國志·夏侯淵傳》「備夜燒圍鹿角。淵使張郃護東圍，自將輕兵護南圍。備挑郃戰，郃軍不利。淵分所將兵半助郃，爲備所襲，淵遂戰死。」
 *       《法正傳》：正曰「可擊矣」，先主命黃忠乘高鼓譟攻之。
 *       《武帝紀》注引《九州春秋》：曹操在漢中進退兩難，出令「雞肋」，主簿楊修便自行收拾行裝，說「夫雞肋，棄之如可惜，食之無所得」。
 * 流程：1. 操作夏侯淵修補被燒的鹿角（站著讀條），山上的劉備軍不時放箭騷擾。修到一半，法正喊「可擊矣」，黃忠從山上鼓譟衝下——這一戰贏不了（劇情）。
 *       2. 改操作曹操：在漢中相持不下，出令「雞肋」，帶兵往西撤回陽平關；山上會有伏兵。到陽平關即結束，曹操傳在這裡收尾。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, hero, swapPlayer, TROOPS, rout, vanish } from '../kit.ts';
import { HILL, CAMP, ABATIS, EXIT, HQ } from '../maps/dingjun.ts';

const LV = 14;
const SHU = { spec: TROOPS.shu, name: '蜀兵', hp: 480, maxHp: 480, atk: 28, ms: 250 };

export default {
  id: 'caocao-12', map: 'dingjun', hero: 'xiahouyuan',
  title: '第 12 章　定軍山與雞肋', year: '建安二十四年（219）',
  brief: {
    quote: [{ text: '備夜燒圍鹿角。淵使張郃護東圍，自將輕兵護南圍。', src: '《三國志·魏書·夏侯淵傳》' }],
    text: '劉備進兵漢中，夏侯淵與張郃拒守。劉備在定軍山扎營，夜裡燒了魏營的鹿角。夏侯淵親自帶輕兵去修補南面的鹿角。',
    goals: ['修補被燒的鹿角', '（夏侯淵戰死是劇情）', '改操作曹操：雞肋，撤回陽平關'],
  },
  words: { ally: '魏軍', foe: '蜀兵' },
  stars: [
    { text: '黃忠衝下來之前修好兩處鹿角', ok: (m) => m.vars.fixed >= 2 },
    { text: '撤退時曹操的生命保住一半以上', ok: (m) => m.vars.caoMin >= 0.5 },
    { text: '帶 5 人以上撤回陽平關', ok: (m) => m.vars.out >= 5 },
  ],
  steps: [
    { // 1. 修鹿角
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = CAMP[0]; me.y = CAMP[1] + 200;
        V.fixed = 0; V.t0 = w.t; V.volT = 4;
        V.men = Array.from({ length: 6 }, (_, i) => { const u = m.recruit(me.x - 100 + (i % 3) * 60, me.y + 80 + Math.floor(i / 3) * 70, '魏軍'); u.spec = TROOPS.wei; m.join(u, me); return u; });
        ABATIS.forEach(([x, y], k) => { m.mark('a' + k, x, y, '被燒的鹿角', true); m.folk(x, y, { name: '鹿角', still: true, near: 1, burntAbatis: true, draw: brokenAbatis }); });
        m.card('備夜燒圍鹿角。', '《夏侯淵傳》');
        m.line('夏侯淵', '張郃守東圍，我帶輕兵把南圍的鹿角補起來！');
        m.after(4, () => m.line('提示', '站在被燒的鹿角旁不動就能修補；山上的劉備軍會放箭（紅圈）。'));
        m.obj('fix', '修補被燒的鹿角', 3);
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        V.volT -= dt;
        if (V.volT <= 0) { V.volT = 2.6; m.strike(me.x + (SG.rand() - 0.5) * 260, me.y + (SG.rand() - 0.5) * 160, 120, 1.2, 50, 0); }
        ABATIS.forEach(([x, y], k) => {
          if (V['fix' + k]) return;
          m.chanAt(me, 'a' + k, x, y + 90, 160, 3.5, '補鹿角', () => {
            V['fix' + k] = true; V.fixed++; m.unmark('a' + k);
            const f = m.folks.find((o) => o.burntAbatis && SG.gd(o.x, o.y, x, y) < 10); if (f) f.fixed = true;
          }, { hurt: false });
        });
        m.prog('fix', V.fixed);
        return V.fixed >= 2 || w.t - V.t0 > 55;
      },
    },
    { // 2. 可擊矣：黃忠乘高鼓譟
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('fix');
        m.card('正曰：「可擊矣。」先主命黃忠乘高鼓譟攻之。', '《法正傳》');
        V.hz = boss(w, hero('huangzhong'), HILL[0], HILL[1] + 200, { name: '黃忠', hp: 7000, atk: 70, armor: 10, ms: 280 });
        V.hz.home = [me.x, me.y];
        V.charge = Array.from({ length: 10 }, (_, i) => { const u = m.foe('huangjin', HILL[0] - 300 + (i % 5) * 120, HILL[1] + 300 + Math.floor(i / 5) * 100, SHU); u.home = [me.x, me.y]; return u; });
        for (const u of V.charge.concat(V.hz)) w.addBuff(u, { id: '鼓譟', t: 20, atkP: 0.4, ms: 0.2 });
        m.big('黃忠殺下山來了！');
        // 夏侯淵撐不住：打到剩兩成就是結局
        const pk = w.xPreKill;
        w.xPreKill = function (src, t) { if (t === me && m.i === 1) { t.hp = 1; return true; } return pk.call(this, src, t); };
        V.t1 = w.t;
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        V.hz.home = [me.x, me.y];
        return me.hp < me.maxHp * 0.2 || w.t - V.t1 > 25;
      },
    },
    { // 3. 淵遂戰死；改操作曹操
      enter(m, w) {
        const V = m.vars, yuan = w.player;
        m.card('淵分所將兵半助郃，爲備所襲，淵遂戰死。', '《夏侯淵傳》');
        rout(m, w, V.charge, HILL); V.hz.untargetable = true; V.hz.home = HILL.slice();
        m.after(1, () => { vanish(w, V.hz); vanish(w, yuan); });
        const cao = ally(w, 'caocao', HQ[0], HQ[1], LV);
        swapPlayer(w, cao);
        V.cao = cao; V.caoMin = 1;
        V.army = Array.from({ length: 10 }, (_, i) => { const u = m.recruit(HQ[0] - 100 - (i % 5) * 50, HQ[1] + 80 + Math.floor(i / 5) * 70, '魏軍'); u.spec = TROOPS.wei; m.join(u, cao); return u; });
        m.after(3, () => m.card('時王欲還，出令曰「雞肋」。', '《九州春秋》（裴注）'));
        m.after(7, () => m.line('楊修', '夫雞肋，棄之如可惜，食之無所得。魏王是要回去了。'));
        m.after(11, () => m.line('提示', '現在操作曹操：帶兵往西撤回陽平關。山上有劉備的伏兵。'));
        m.mark('exit', EXIT[0], EXIT[1], '陽平關');
        m.obj('back', '撤回陽平關');
        // 沿路的伏兵
        V.amb = [[2900, 2400], [2000, 3500]].map(([x, y]) => ({ x, y, done: false }));
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        V.caoMin = Math.min(V.caoMin, me.hp / me.maxHp);
        for (const a of V.amb) if (!a.done && SG.gd(me.x, me.y, a.x, a.y) < 700) {
          a.done = true; m.line('蜀兵', '殺！');
          for (let i = 0; i < 5; i++) { const u = m.foe('huangjin', a.x + (i % 3) * 70, a.y + Math.floor(i / 3) * 80, SHU); u.home = [me.x, me.y]; }
        }
        if (!m.near(me, EXIT[0], EXIT[1], 300)) return false;
        V.out = m.alive(V.army).filter((u) => SG.gd(u.x, u.y, me.x, me.y) < 800).length;
        return true;
      },
    },
    { // 4. 曹操傳收尾
      enter(m) {
        m.done('back'); m.unmark('exit');
        m.card('二十五年春正月，至洛陽。……庚子，王崩於洛陽，年六十六。', '《武帝紀》');
        m.after(7, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    if (!w.player.alive) m.lose(m.i >= 2 ? '曹操陣亡' : '夏侯淵陣亡');
  },
};

// 被燒的鹿角（修好就換成完好的鹿角）
function brokenAbatis(ctx, f, T) {
  ctx.save(); ctx.translate(f.x, f.y);
  ctx.lineCap = 'round';
  for (let i = 0; i < 5; i++) {
    const x = -90 + i * 45;
    ctx.strokeStyle = f.fixed ? '#5a3a22' : '#2a2420'; ctx.lineWidth = 6;
    ctx.beginPath(); ctx.moveTo(x - 16, 6); ctx.lineTo(x + 12, f.fixed ? -44 : -24); ctx.moveTo(x + 16, 6); ctx.lineTo(x - 12, f.fixed ? -44 : -18); ctx.stroke();
    if (!f.fixed) { ctx.fillStyle = 'rgba(255,120,40,.35)'; ctx.beginPath(); ctx.arc(x, -14, 5 + Math.sin(T * 6 + i) * 2, 0, Math.PI * 2); ctx.fill(); }
  }
  ctx.restore();
}
